import React, { useEffect, useState } from 'react'
import { mondayService } from '../services/mondayService'

export const useGetMondayData = (data: string, setMondayError: React.Dispatch<React.SetStateAction<boolean>>): DropDownOption[] | any => {
  const [mondayData, setMondayData] = useState<DropDownOption[] | number>()

  useEffect(() => {
    ;(async (): Promise<void> => {
      const mondayData: number | DropDownOption[] | undefined = await mondayService.getMondayDetails(data, setMondayError)
      setMondayData(mondayData)
    })()
  }, [data, setMondayError])

  return mondayData
}
